"use client";

import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(changed: () => void) {
  const list = window.matchMedia(QUERY);
  list.addEventListener("change", changed);
  return () => list.removeEventListener("change", changed);
}

/** Whether the reader asked for less motion (false while the page is built, and until it hydrates). */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false
  );
}
